import { WidgetAutocheck } from "@redotech/redo-model/widget";
import { isDef } from "@redotech/util/checks";

export function isRIC(autocheck: WidgetAutocheck): boolean {
  const isCheckoutButtons =
    isDef(autocheck.widgetConfigs) &&
    autocheck.widgetConfigs.length > 0 &&
    ["checkout-button-shipping", "checkout-button-product"].includes(
      autocheck.attachmentStrategy,
    );

  return isCheckoutButtons;
}
